let errorHandler = (err) => {
    console.log(err);
};
export const AuthPromise = new Promise((resolve, reject) => {
    // DSZ: blws/auth/wi/get, Exchange OIDC JWT to NATS JWT
    fetch('/auth', { method: 'POST' }).then((result) => {
        if (Math.trunc(result.status / 100) == 2) {
            result.json().then((ret) => {
                resolve(ret);
            }).catch(errorHandler).catch(reject);
        }
        else {
            result.text().then((err) => {
                reject(err);
                errorHandler(err);
            }).catch(reject);
        }
    }).catch((e) => {
        errorHandler(e);
        reject(e);
    });
});
